export {
  unstable_routeRSCServerRequest as routeRSCServerRequest,
  unstable_RSCStaticRouter as RSCStaticRouter,
} from 'react-router';
export {
  unstable_RSCHydratedRouter as RSCHydratedRouter,
  unstable_createCallServer as createCallServer,
  unstable_getRSCStream as getRSCStream,
} from 'react-router/dom';
